export enum MaintenanceFormStatus {
  Completed = "Completed",
  InProgress = "In Progress",
}